import React from 'react';

interface DisclaimerPageProps {
  onAccept: () => void;
  onReject: () => void;
}

export const DisclaimerPage: React.FC<DisclaimerPageProps> = ({ onAccept, onReject }) => {
  return (
    <div className="disclaimer-page">
      <div className="disclaimer-container">
        <div className="disclaimer-header">
          <h1>⚠️ Disclaimer</h1>
        </div>

        <div className="disclaimer-content">
          <div className="disclaimer-section">
            <div className="flag-emoji">🇮🇹</div>
            <div className="disclaimer-text">
              <p>
                Queste previsioni meteo sono fornite a puro titolo indicativo e soggette ad interpretazione. 
                Gli autori non saranno in alcun modo responsabili delle eventuali conseguenze derivanti da errori 
                nelle previsioni o dall'interpretazione errata delle stesse durante la pratica di qualsiasi 
                attività outdoor, incluso il VDS.
              </p>
            </div>
          </div>

          <div className="disclaimer-divider"></div>

          <div className="disclaimer-section">
            <div className="flag-emoji">🇬🇧</div>
            <div className="disclaimer-text">
              <p>
                The Authors make any representations or warranties, either expressed or implied, as to the 
                accuracy of the information held herein or its fitness for any purpose whatsoever. In no event 
                will either party be held liable for any direct, indirect, special incidental or consequential 
                damages arising out of the use of the information held herein.
              </p>
            </div>
          </div>
        </div>

        <div className="disclaimer-actions">
          <button className="btn-accept" onClick={onAccept}>
            ✓ Accetto
          </button>
          <button className="btn-reject" onClick={onReject}>
            ✗ Rifiuto
          </button>
        </div>
      </div>
    </div>
  );
};
